import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'

export async function authGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()
  
  // Vérifier l'authentification seulement si nécessaire
  authStore.checkAuth()
  
  // Routes qui ne nécessitent pas d'authentification
  const publicRoutes = ['/login', '/forgot-password', '/reset-password']
  const isPublicRoute = publicRoutes.some(route => to.path.startsWith(route))
  
  // Si c'est une route publique, autoriser l'accès
  if (isPublicRoute) {
    next()
    return
  }
  
  // Si l'utilisateur n'est pas connecté et essaie d'accéder à une route protégée
  if (!authStore.isAuthenticated && to.meta.requiresAuth !== false) {
    // Rediriger vers la page de connexion
    next('/login')
    return
  }
  
  // Si l'utilisateur est connecté et essaie d'accéder à la page de connexion
  if (authStore.isAuthenticated && to.path === '/login') {
    // Rediriger vers le dashboard
    next('/dashboard')
    return
  }
  
  // Vérifier les permissions si spécifiées
  if (to.meta.permissions) {
    const requiredPermissions = to.meta.permissions as string[]
    const hasPermission = requiredPermissions.some(permission => 
      authStore.hasPermission(permission)
    )
    
    if (!hasPermission) {
      // Rediriger vers une page d'erreur 403 ou le dashboard
      next('/dashboard')
      return
    }
  }
  
  // Vérifier les rôles si spécifiés
  if (to.meta.roles) {
    const requiredRoles = to.meta.roles as string[]
    const hasRole = requiredRoles.some(role => 
      authStore.hasRole(role)
    )
    
    if (!hasRole) {
      // Rediriger vers une page d'erreur 403 ou le dashboard
      next('/dashboard')
      return
    }
  }
  
  // Autoriser l'accès
  next()
}
